module.exports = __webpack_public_path__ + "img/poly-5.1573aa3f.png";